import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var save = normalize.save(function (options) {
  var tempFilePath = options.tempFilePath,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  swan.saveFile({
    tempFilePath: tempFilePath,
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BAIDU);
export default save;